export default __webpack_public_path__ + "static/media/b-7.c0627b75.svg";